import "./App.scss";
import { RouterProvider } from "react-router-dom";
import { Router } from "./routes/route";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
const client = new QueryClient();
function App() {
  return (
    <div className="notification-app" data-testid="notification-app">
      <QueryClientProvider client={client}>
        <RouterProvider router={Router} />
      </QueryClientProvider>
    </div>
  );
}

export default App;
